module.exports = __webpack_public_path__ + "img/image-eyecam.4e449497.jpg";